import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import { BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM/*, BUSINESS_SECTOR_ENUM */ } from '../interfaces';

export const businessAccountRequestStatusFilter: Filter = {
  filter: 'common:status',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'status',
  field: 'status',
  options: Object.values(BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM).map((value) => ({
    value,
    translate: true,
    label: `businessAccountRequest:status.${value}`,
  })),
};

// export const businessAccountRequestSectorFilter: Filter = {
//   filter: 'businessAccountRequest:fields.sector',
//   translate: true,
//   type: FilterType.FIXED_LIST,
//   key: 'sector',
//   field: 'company.sector',
//   options: Object.values(BUSINESS_SECTOR_ENUM).map((value) => ({
//     value,
//     translate: true,
//     label: `businessAccountRequest:sector.${value}`,
//   })),
// };

export const businessAccountRequestFilters = [
  businessAccountRequestStatusFilter,
  // businessAccountRequestSectorFilter,
  createdATFilter,
];
